export const environment = {
  production: false,
  apiBase: 'https://api.sta.delta.appserver.com.br/api/v1/',
  xApiKey: 'CbIfd6c3y4q5ErM1weIew1lr0Be9g08gchvZ6A8RpFJnlX0yFr',
  sessionTimeoutMinutes: 30,
  tokenLeewaySeconds: 5,
  version: '0.1.29',
}
// apiBase: 'http://localhost:8080/api/v1/',
